<template>
    <div id="bar" style="width: 100%;height:400px" class="m-t-20"></div>
</template>
  
<script>
import echarts from 'echarts'
// title: {text: 标题, subtext: 子标题, x:标题的位置 left, center, right}
// legend: {orient: 标签的显示方向horizontal,vertical，left: 标签的位置left,center,right，data: 标签的数据 }
// directionData: 坐标轴的类型
// series: 多维数组，每一个数组对应坐标轴类型的一种数据
// direction: 横向，纵向
// color: 坐标轴每一种类型柱状图的颜色
// tooltip{show: 是否显示数据标签}
// isShowAsix 显示坐标轴
// isShowSplitLine 是否显示网格
export default {
  name: 'dimensionalBar',
  // props: ['title', 'tooltip', 'legend', 'direction', 'directionData', 'series', 'color', 'isShowAsix', 'isShowSplitLine']
  props: ['bar'],
  data () {
    return {
      charts: ''
    }
  },
  created() {
    setTimeout(() => {
      this.drawPie('bar')
    },50)
  },
  methods: {
    drawPie (id) {
      this.charts = echarts.init(document.getElementById(id))
      let option = {
        title: this.bar.title,
        tooltip: {
          show: this.bar.tooltip.isShow,   // 是否显示数据标签
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: this.bar.tooltip.formatter == '' ? '' : this.bar.tooltip.formatter
        },
        legend: this.bar.legend,
        series: [],
        xAxis: {
          // 坐标轴上的标签
          axisLabel: {
            show: true
          },
          axisLine: {
            show: this.bar.isShowAsix
          },
          splitLine: {
            show: this.bar.isShowSplitLine
          }
        },
        yAxis: {
          axisLabel: {
            show: true
          },
          axisLine: {
            show: this.bar.isShowAsix
          },
          splitLine: {
            show: this.bar.isShowSplitLine
          }
        }
      }
      // 判断柱状图的方向并获取数值
      if (this.bar.direction === 10) {
        option.xAxis['type'] = 'category'
        option.xAxis['data'] = this.bar.directionData
        option.xAxis.splitLine.show = false
      } else {
        option.yAxis['type'] = 'category'
        option.yAxis['data'] = this.bar.directionData
        option.yAxis.splitLine.show = false
      }
      // 是否显示坐标轴(包括标签页不显示)
      // option.xAxis.show = this.isShowAsix
      // option.yAxis.show = this.isShowAsix
      // 渲染柱状图各种类型的颜色
      if (this.bar.color && this.bar.color.length > 0) {
        option.color = this.bar.color
      }
      // 每一种类型的
      _.forEach(this.bar.series, (v, i) => {
        option.series.push({
          name: this.bar.legend.data[i],
          type: 'bar',
          data: v
        })
      })
      this.charts.setOption(option)
    }
  },
  // 调用
  // mounted () {
  //   this.$nextTick(function () {
  //     this.drawPie('main2')
  //   })
  // },
  watch: {
    'bar'() {
      this.drawPie('bar')
    }
  },
  components: {
    echarts
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// dimensionalBar.vue?4038482c